var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "play_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6.799c0-3.296 3.762-5.178 6.399-3.201l7.997 5.993c2.135 1.6 2.135 4.802 0 6.402L12.4 21.986C9.762 23.962 6 22.08 6 18.785V6.799zm5.2-1.6C9.88 4.21 8 5.15 8 6.798v11.986c0 1.648 1.88 2.588 3.2 1.6l7.997-5.993a2 2 0 0 0 0-3.2l-7.998-5.994z",
    fill: "currentColor"
  })));
};

export { SvgPlay as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYgNi43OTljMC0zLjI5NiAzLjc2Mi01LjE3OCA2LjM5OS0zLjIwMWw3Ljk5NyA1Ljk5M2MyLjEzNSAxLjYgMi4xMzUgNC44MDIgMCA2LjQwMkwxMi40IDIxLjk4NkM5Ljc2MiAyMy45NjIgNiAyMi4wOCA2IDE4Ljc4NVY2Ljc5OXptNS4yLTEuNkM5Ljg4IDQuMjEgOCA1LjE1IDggNi43OTh2MTEuOTg2YzAgMS42NDggMS44OCAyLjU4OCAzLjIgMS42bDcuOTk3LTUuOTkzYTIgMiAwIDAwMC0zLjJsLTcuOTk4LTUuOTk0eiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";